/**
 * Shared filter-modal helpers for location loading/sync.
 * Used by appointments-filter-modal and campaign-filter-modal.
 */
import { Observable, Subscription } from 'rxjs';

export interface FilterLocationItem {
  value: string;
  label: string;
  checked: boolean;
}

export function mapApiLocationsToFilterItems(apiLocations: { id: string; branch: string }[]): FilterLocationItem[] {
  return apiLocations.map(location => ({
    value: location.id,
    label: location.branch,
    checked: false,
  }));
}

export function syncLocationSelections(
  locations: FilterLocationItem[],
  currentLocationLabels: string[] | null | undefined
): void {
  if (currentLocationLabels && currentLocationLabels.length > 0) {
    locations.forEach(location => {
      location.checked = currentLocationLabels.includes(location.label);
    });
  }
}

export function getSelectedLocationLabels(locations: FilterLocationItem[]): string[] {
  return locations.filter(loc => loc.checked).map(loc => loc.label);
}

/**
 * Load locations and subscribe to locations$; update state.locations and sync with state.currentLocationLabels.
 * Use in campaign-filter-modal and appointments-filter-modal to avoid duplicating loadLocations().
 */
export function subscribeToLocationsForFilterModal(
  profileService: { loadLocations(): void; locations$: Observable<any> },
  state: { locations: FilterLocationItem[]; currentLocationLabels: string[] }
): Subscription {
  profileService.loadLocations();
  return profileService.locations$.subscribe(apiLocations => {
    state.locations = mapApiLocationsToFilterItems(apiLocations);
    syncLocationSelections(state.locations, state.currentLocationLabels);
  });
}
